import React from 'react'

interface SectionProps {
  children: React.ReactNode
  className?: string
  id?: string
}

const Section: React.FC<SectionProps> = ({ children, className = '', id }) => {
  return (
    <section id={id} className={`py-16 md:py-20 ${className}`}>
      <div className="max-w-1200 mx-auto px-6">{children}</div>
    </section>
  )
}

export default Section
